import { dispatchFavoriteAddedEvent, dispatchFavoriteRemovedEvent } from './events';
import { FavoriteTripsService } from './FavoriteTripsContext';

export const LOCAL_STORAGE_KEY = 'fpData';

export class LocalStorageFavoritesService implements FavoriteTripsService {
  private setFavorites: ((favorites: string[]) => void) | null = null;
  private favorites: string[];

  constructor() {
    this.favorites = this.loadFavorites() ?? [];
  }

  subscribe = (setFavoritesCallback: (f: string[]) => void) => {
    this.setFavorites = setFavoritesCallback;
    this.setFavorites(this.favorites);
  };

  loadFavorites = (): string[] | null => {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (storedData) {
      try {
        const data = JSON.parse(storedData);
        return data.favorites ?? null;
      } catch (error) {
        console.error('Failed to parse favorites from localStorage:', error);
        this.clearFavorites();
      }
    }
    return null;
  };

  clearFavorites = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  addFavoriteTrip = (tripId: string) => {
    const updatedFavorites = [...this.favorites, tripId];
    dispatchFavoriteAddedEvent(tripId);
    this.saveFavoriteTrips(updatedFavorites);
  };

  removeFavoriteTrip = (tripId: string) => {
    const updatedFavorites = this.favorites.filter((favorite) => favorite !== tripId);
    dispatchFavoriteRemovedEvent(tripId);
    this.saveFavoriteTrips(updatedFavorites);
  };

  saveFavoriteTrips = (favorites: string[]) => {
    const existingData = this.loadFavorites();
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ ...existingData, favorites }),
    );
    this.favorites = favorites;
    this.setFavorites?.(favorites);
  };
}
